<!-- 比較頁面 -->
<template>
  <div id="Compare">
    <Consultation
        v-if="showConsultationForm"
        :showConsultationForm.sync="showConsultationForm"
        :hasSendConsultation.sync="hasSendConsultation"
        :qpSimulationReportArr="qpSimulationReportArr"
        :type="type"
    >
    </Consultation>
    <div v-show="!hasPlan" class="empty">
      <div class="empty-icon">
        <i class="fas fa-plus-circle"></i>
        <i class="fas fa-vial"></i>
      </div>
      <div class="empty-text">
        本頁面用來比較多筆廣告預估結果，目前尚無任何資料。
        <br>
        請先至「計算頁面」進行計算，並將預估結果加入「計算總覽」。
      </div>
    </div>
    <div v-show="hasPlan">
      <div class="compare-info">
        <div class='center'>※ 此資料將在您離開本系統後清空，如須留存規劃內容，請於計算頁面「匯出」計算結果</div>
        <!-- <el-button
          @click="exportData"
          :disabled="selectedCompareData.length === 0"
          type="primary">輸出比較圖與勾選項目明細</el-button> -->
      </div>
      <!-- 圖表 -->
      <div class="chart">
        <HighChart
        :globalOption="globalOption"
        :chartOptions="option"
        :compareChartData="chartData"></HighChart>
      </div>
      <div class="data-batch-controller">
        <el-checkbox v-model="isAllSelected" style="font-weight: 600;">全選</el-checkbox>
        <div class="buttons">
          <!-- <Merge :data="compareUnitDataThatCanBeMerged" @merge="mergeCompareData"></Merge> -->
          <el-button class="tool-btn" icon="fas fa-print" :disabled="isExportingReport || selectedPlanDataList.length === 0" @click="exportData"> 輸出選取項目({{selectedPlanDataList.length}})</el-button>
          <el-button class="tool-btn" icon="fas fa-comment-dots" @click="sendData"> 洽詢選取項目({{selectedPlanDataList.length}})</el-button>
        </div>
      </div>
      <!-- 資料區 -->
      <div class="data-container">
        <Plan
              v-for="(data, index) in planManager.planDataList"
              :index="index"
              :key="index"
              :data="data"
              @checked="choosePlan"
              @rename="renamePlan"
              @delete="deletePlan"
              @cancelMerge="cancelMerge"
        ></Plan>
      </div>
    </div>
    <!-- Canvas 容器，SVG => Canvas => Base64 -->
    <canvas id="canvasImage" width="992" height="320" style="display: none"></canvas>
  </div>
</template>

<script>
import exportApi from '@/api/export'
import { mapState, mapGetters, mapActions } from 'vuex'
import { option, globalOption } from '@/config/charts/compareChartConfig'
import HighChart from '@/components/HighChart'
//
import Highcharts from 'highcharts'
import canvg from 'canvg'
import Plan from './Plan'
import Merge from './Merge'
import PlanManager from './planManager'
import Consultation from '../Consultation'

import { PRODUCT_LINE } from '@/constant'

export default {
  name: 'Compare',
  components: {
    Merge,
    HighChart,
    Consultation,
    Plan
  },
  data () {
    return {
      type: 'all',
      option,
      globalOption,
      chartData: {},
      planManager: new PlanManager(),
      isExportingReport: false,
      // consultation related data
      showConsultationForm: false,
      hasSendConsultation: false
    }
  },
  computed: {
    ...mapState('calculation', ['compareDataList']),
    ...mapState('speedCalculation2', { speedOptions: 'options' }),
    ...mapState('directCalculation', { directOptions: 'options' }),
    ...mapGetters('root', ['userType']),
    ...mapGetters('permission', ['isInsider']),
    selectedPlanDataList () {
      return this.planManager.getSelectedPlanDataList()
    },
    hasPlan () {
      return this.planManager.planDataList.length > 0
    },
    isAllSelected: {
      get () {
        return this.planManager.checkIfAllSelected()
      },
      set (val) {
        this.planManager.batchTogglePlans(val)
      }
    },
    compareUnitDataThatCanBeMerged () {
      return this.planManager.getCompareUnitDataThatCanBeMerged()
    },
    qpSimulationReportArr () {
      return this.planManager.getQpSimulationReportArr(
        { speed: this.speedOptions, direct: this.directOptions },
        this.selectedPlanDataList,
        this.isInsider
      )
    }
  },
  watch: {
    selectedPlanDataList: {
      handler () {
        this.setChartData()
      },
      deep: true
    }
  },
  created () {
    this.planManager.resetData(this.compareDataList, this.removeCompareData)
  },
  methods: {
    ...mapActions('calculation', ['removeCompareData']),
    ...mapActions('speedCalculation2', { setSpeedOptions: 'setOptions' }),
    ...mapActions('directCalculation', { setDirectOptions: 'setOptions' }),
    // 設定圖表資料
    setChartData () {
      const chartData = {
        nameList: this.selectedPlanDataList.map(plan => plan.planName),
        dataList: {
          SITotalUU: [],
          SIReachUU: [],
          SVTotalUU: [],
          SVReachUU: [],
          LINETotalUU: [],
          LINEReachUU: []
        }
      }
      this.selectedPlanDataList.map(plan => {
        let SITotalUU = 0
        let SIReachUU = 0
        let SVTotalUU = 0
        let SVReachUU = 0
        let LINETotalUU = 0
        let LINEReachUU = 0

        plan.compareUnitDataList.forEach(({ compareData }) => {
          const totalUu = compareData.calculationResult.cross_device['total_uu']
          const ReachUu = compareData.calculationResult.cross_device['reach_uu']
          const mobileTotalUu = compareData.calculationResult.mobile['total_uu']
          const mobileReachUu = compareData.calculationResult.mobile['reach_uu']
          switch (compareData.selectedProductLine) {
            case PRODUCT_LINE.SUPER_IMPACT:
              SITotalUU += totalUu
              SIReachUU += ReachUu
              break
            case PRODUCT_LINE.SUPER_VIEW:
              SVTotalUU += totalUu
              SVReachUU += ReachUu
              break
            case PRODUCT_LINE.LINE_TODAY:
              LINETotalUU += mobileTotalUu
              LINEReachUU += mobileReachUu
              break
          }
        })

        chartData.dataList.SITotalUU.push(SITotalUU)
        chartData.dataList.SIReachUU.push(SIReachUU)
        chartData.dataList.SVTotalUU.push(SVTotalUU)
        chartData.dataList.SVReachUU.push(SVReachUU)
        chartData.dataList.LINETotalUU.push(LINETotalUU)
        chartData.dataList.LINEReachUU.push(LINEReachUU)
      })

      this.chartData = chartData
    },
    /**
     * 取得圖表 base64 data
     * 1. 透過 HighCharts 本身提供的 API - getSVG() 取得圖表的 SVG 結構
     * 2. 透過 canvg 將取得的 SVG 結構轉換為 canvas 資料放進預先建立的 canvas 容器
     * 3. 透過 toDataURL 將 canvas 內圖片轉為 base64 資訊
     */
    getChartImageData () {
      const chartDom = document.querySelector('#highChart')
      const chartSVGData = Highcharts.charts[Highcharts.attr(chartDom, 'data-highcharts-chart')].getSVG()
      const canvasId = 'canvasImage'
      const canvasDom = document.querySelector(`#${canvasId}`)
      canvg(canvasId, chartSVGData)
      const imageData = canvasDom.toDataURL('image/png')
      return imageData.replace('data:image/png;base64,', '')
    },
    // 匯出資料
    exportData () {
      this.isExportingReport = true
      const exportData = {
        qp_simulation_report: this.qpSimulationReportArr,
        type: this.type
      }

      exportApi.exportSimulationReport(exportData)
        .then(res => {
          const objectUrl = window.URL.createObjectURL(new Blob([res.data], { type: '' }))
          const link = document.createElement('a')
          link.className = 'download-report'
          link.href = objectUrl
          link.setAttribute('download', 'OneAD QuickPlan 規劃匯出.xlsx')
          document.body.appendChild(link)
          link.click()
          document.querySelector(`.${link.className}`).remove()
          this.isExportingReport = false
        })
        .catch(() => {
          this.isExportingReport = false
          this.$message.error('匯出失敗!')
        })
    },
    sendData () {
      this.showConsultationForm = true
    },
    choosePlan ({ index, checked }) {
      this.planManager.choosePlan(index, checked)
    },
    rearrangePlanList () {
      this.planManager.rearrangePlanList()
    },
    mergeCompareData ({ chosenCompareUnitDataArr, newPlanName }) {
      this.planManager.mergeCompareData(chosenCompareUnitDataArr, newPlanName)
    },
    cancelMerge (index) {
      this.planManager.cancelMerge(index)
    },
    renamePlan ({ index, name }) {
      this.planManager.renamePlan(index, name)
    },
    deletePlan (index) {
      this.planManager.deletePlan(index)
    }
  }
}
</script>

<style lang="scss" scoped>
#Compare {
  .compare-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    color: #f27474;
  }
  .center { margin: 0 auto; }
  .data-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 992px;
    margin: 16px auto;
    .buttons{
      margin-bottom: 23px;
    }
    .data {
      position: relative;
      margin-bottom: 20px;
      padding: 16px;
      width: 992px;
      background-color: #fff;
      box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
      &-open-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        padding: 8px;
        width: 100%;
        border: none;
        background-color: #eeeeee;
        color: #444444;
        cursor: pointer;
        i {
          margin-right: 8px;
          font-size: 20px;
        }
      }
      &-close-btn {
        position: absolute;
        right: 16px;
        color: #9b9b9b;
        font-size: 20px;
        cursor: pointer;
      }
      &-info {
        display: flex;
        border-bottom: solid 1px #d8d8d8;
        &-name {
          padding: 16px;
          min-width: 20%;
          border-right: solid 1px #d8d8d8;
          .el-checkbox {
            display: flex;
            white-space: normal;
            font-weight: normal;
            &__label {
              font-size: 16px;
              line-height: 1.4;
            }
          }
        }
        &-analysis {
          padding: 16px;
          border-right: solid 1px #d8d8d8;
          text-align: left;
          .analysis-head {
            margin-right: 8px;
            min-width: 152px;
            white-space: nowrap;
          }
        }
        &-target {
          padding: 16px;
          min-width: 40%;
        }
      }
      &-detail {
        .compare-table-column {
          padding: 24px;
          .head {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
  .compare {
    &-table {
      width: 100%;
      &-title {
        margin-bottom: 8px;
        font-weight: 600;
      }
      &-row {
        display: flex;
        &.head {
          font-weight: 600;
        }
      }
      &-column {
        flex: 3;
        padding: 4px 8px;
        min-width: 100px;
        &.head, .head {
          flex: 1;
          width: 100px;
          white-space: nowrap;
          font-weight: 600;
        }
        &.text-right {
          text-align: right;
        }
      }
      &-name {
        margin-top: 16px;
        margin-bottom: 8px;
      }
      &-buttons {
        display: flex;
      }
    }
  }
  .empty {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: calc(100vh - 120px);
    &-icon {
      position: relative;
      display: flex;

      .fa-plus-circle {
        position: absolute;
        top: -20px;
        left: -20px;
        color: #BEE9E8;
        font-size: 80px;
      }
      .fa-vial {
        color: #BEE9E8;
        font-size: 200px;
      }
    }
    &-text {
      margin-top: 36px;
      text-align: center;
      font-size: 18px;
      line-height: 1.5;
    }
  }
}

.tool-btn{
  border-color:#4da1ff;
  color:#4da1ff;
}

.data-batch-controller{
  display: flex;
  max-width: 992px;
  justify-content: space-between;
  margin: 16px auto;
}
</style>
